export default "__VITE_ASSET__COrpY73i__"